import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import Anchor from "../../../dashboardNew/objects/Anchor";

export const BlogSingleListArticle = (props) => {

    const {
        uid,
        title,
        date,
        short_description,
        small_img,
        alternative_text_image,
        //author,
        category,
        is_on_portal
    } = props;

    return (
        <li className="card-item padding-top margin-bottom">
            <div className="card card--blog">
                <Anchor path={`/blog/${uid}`} anchorClass="" internal>
                    <img src={small_img} alt={alternative_text_image} className="img-fluid" />
                </Anchor>
                {
                    // Category
                    category && category.name && (
                        <div className="tag tag--secondary tag--secondary_blue">
                            {category.name}
                        </div>
                    )
                }
                <div className="summary">
                    <h4 className="h4 title">{title}</h4>
                    <div className="description">{RichText.render(short_description)}</div>
                    <Anchor path={`/blog/${uid}`} anchorClass="clickable" internal>Read more</Anchor>
                </div>
            </div>
        </li>
    )
}

BlogSingleListArticle.propTypes = {
    uid: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    short_description: PropTypes.array,
    small_img: PropTypes.string,
    alternative_text_image: PropTypes.string,
    is_on_portal: PropTypes.bool
}



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogSingleListArticle.js